'use client'

import { Common, HttpService, ServiceEndpoints } from '@/config/NextImport'
import { useEffect, useState } from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
const GoogleReviewBanner = (props: any) => {
  const [totalReviews, setTotalReviews] = useState<number>(0)
  const environment = process.env.NEXT_PUBLIC_NODE_ENV
  useEffect(() => {
    if (environment === 'development' || environment === 'staging') {
      // Use static reviews
      setTotalReviews(841)
    } else {
      // Production → API 
      fetchReviews()
    }
  }, [])
  const fetchReviews = async () => {
    HttpService.postApi(ServiceEndpoints.getGoogleReviews, null).then((response: any) => {
      try {
        if (response.result.error_message) {
          return
        }
        if (response.result) {
          setTotalReviews(response.result.result.user_ratings_total)
        }
      } catch (err) {
        console.log(err)
      }
    })
  }

  return (
    <section className="google-review-bar">
      <div className="review-container">
        <div
          className={
            props.PositionCenter
              ? 'review-container-box justify-content-center'
              : 'review-container-box'
          }
        >
          <a
            href="https://goo.gl/maps/DMPiYthseUfYeqjA7"
            target="_blank"
            className="review-link"
          >
            <span className={props.ShowKeyword ? 'review-text d-block' : 'review-text d-none'}>
              EXCELLENT
            </span>
            <img
              src={Common.setImagePath('assets/images/google_icon.svg')}
              alt="Google"
              className="google-logo"
            />
            <div className="stars">
              {
                totalReviews > 0 ? (
                  <>★★★★★</>
                ) : (
                  null
                )
              }
              
            </div>

            {/* Updated review-count container with flex to keep number/skeleton and text inline */}
            <span className="review-count d-inline-flex align-items-center gap-1">
              {totalReviews > 0 ? (
                <span>{totalReviews}</span>
              ) : (
                <Skeleton
                  highlightColor={'#f1ebee'}
                  width={50}
                  height={16}
                  baseColor={'#f1f1f1'}
                  inline={true}
                />
              )}
              <span>reviews</span>
            </span>
          </a>
        </div>
      </div>
    </section>
  )
}
export default GoogleReviewBanner
